<div class="alert-sidebar-empty">
    <app-fn-ui-close-icon (closeClick)="onCloseClick()"></app-fn-ui-close-icon>
    <img src="assets/images/svg/no-alerts.svg">
    <span class="no-alerts-message">{{ 'alert.message.no-alerts' | translate }}</span>
    <span class="check-back-message">{{ 'alert.message.check-back-later' | translate }}</span>
</div>